import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.links = [];
  }

  connect() {
    this.links = this.element.getElementsByTagName("a");
    for (const link of this.links) {
      link.addEventListener("click", () => this.navigate(link));
    }
  }

  disconnect() {
    for (const link of this.links) {
      link.removeEventListener("click", () => this.navigate(link));
    }
  }

  navigate(link) {
    const href = link.getAttribute("href");
    const page = link.getAttribute("page");
    console.log({ page, href });
    if (href != null) {
      history.pushState({ turbo_frame_history: true }, "", href);
    }
  }
}
